// src/Components/ScrollToTop.js

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Clear hash on refresh
    if (window.location.hash) {
      window.history.replaceState(null, null, window.location.pathname);
      window.scrollTo(0, 0);
      // ✅ Remove this line ⬇️
      // setActiveLink("home"); 
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;

